import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import React from 'react';
import { useApi } from "./ApiClient";
import { useCenter } from "./CenterContext";

const UnitContext = createContext();

export function UnitsProvider({ subjectId, children }) {
  const [units, setUnits] = useState([]);
  const [consortiaUnits, setConsortiaUnits] = useState([]);
  const { centerNumber } = useCenter();
  const [loading, setLoading] = useState(true);
   const api = useApi(process.env.REACT_APP_VAF_BASE_URL);

  useEffect(() => {
    if (!subjectId) return;
    setLoading(true);
    const fetchUnits = async () => {
      try {
        const response = await api.get(
          `getAssessments?subject_id=${subjectId}&centre_number=${centerNumber}`
        );
        setUnits(response.data.data.assessments || []);
        setConsortiaUnits(response.data.data.consortiaAssessments || []);        
      } catch (error) {
        setUnits([]);
        setConsortiaUnits([]);
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchUnits();
  }, [subjectId]);
  return (
    <UnitContext.Provider value={{ units, loading , consortiaUnits}}>
      {children}
    </UnitContext.Provider>
  );
}

export function useUnits() {
  return useContext(UnitContext) || { units: [], consortiaUnits: [] };
}
